import { globalStore } from '@/assets/js/common/utils'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader.js'
let modelPath = (location.hostname === "localhost") ? '/assets/glb/' : '/sites/all/themes/oceanpark/glb/';
let imgPath = (location.hostname === "localhost") ? 'https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/' : '/sites/all/themes/oceanpark/img/';
import THREE, { AnimationMixer, Scene, HemisphereLight, WebGLRenderer, PerspectiveCamera,
	PlaneGeometry, ImageUtils, MeshLambertMaterial, Mesh, DirectionalLight, AdditiveBlending,
	TextureLoader, PointLight, SpotLight, LoopOnce,
	CubeUVReflectionMapping, CubeTextureLoader, Clock, Group } from 'three';
import gsap from "gsap";

// import Swiper JS
export class Entrance 
{
	allowMouse:any = false;
	animated:any = false;
	finished:any = false;
	cursor:any = document.querySelector(".halloween-2025-entrance-cursor");
	cursorButton:any = document.querySelector(".halloween-2025-entrance-cursor-inner");
	wrapper:any = document.querySelector(".halloween-2025-entrance-inner");
	indicatorCircle:any = this.cursorButton.querySelector(".indicator-circle > .fill-area circle");
	camera:any = null;
	gltf:any = null;
	mixer:any = null;
	group:any = null;

	constructor(){
		this.smoke();

		document.addEventListener("mousemove", this.parallax, true);
		this.buttonPress();
		// if(this.cursorButton){
		// 	this.cursorButton.addEventListener("click", this.openingAnimation, true);
		// }

		this.debugMode();
	}
	loadScript(url:any, callback:any) {
		const script = document.createElement('script');
		script.src = url;
		script.onload = () => {
			if (callback) {
				callback();
			}
		};
		script.onerror = () => {
			console.error(`Error loading script: ${url}`);
		};
		document.head.appendChild(script);
	}
	parallax = (event:any)=> {
		document.querySelectorAll(".halloween-2025-parallax").forEach((shift:any) => {
			const position = shift.getAttribute("value");
			const x = (window.innerWidth - event.pageX * position) / 90;
			const y = (window.innerHeight - event.pageY * position) / 90;

			shift.style.transform = `translateX(${x}px) translateY(${y}px)`;
		});
		if(this.cursor){
			const x = event.clientX;
			const y = event.clientY;
			this.cursor.style.transform = `translateX(${x}px) translateY(${y}px)`;
		}
	}
	openingAnimation = ()=>{
		const _this = this;
		document.removeEventListener("mousemove", this.parallax, true);
		if(this.cursorButton){
			this.cursorButton.removeEventListener("click", this.openingAnimation, true);
		}
		if(!this.animated){
			// console.log('animation!');
			_this.allowMouse = false;
			this.animated = true;

			gsap.to(_this.group.rotation, { 
				duration: .4, 
				ease: "power2.out",
				x: 0,
				y: -.4,
			});

			document.querySelector('.footer')?.classList.add('show-footer');
			document.querySelector(".halloween-2025-index-container")?.classList.add('animation-entered');
			document.querySelector(".halloween-2025-entrance-cursor")?.classList.add('masking-out');
			setTimeout(()=>{
				document.querySelector(".halloween-2025-intro-sponsors")?.classList.add('masking-out');
				setTimeout(()=>{
					document.querySelector(".halloween-2025-entrance-logo")?.classList.add('masking-out');
					// console.log('stage 1');

					_this.gltf.animations.forEach( (clip:any) => {
						const action = _this.mixer.clipAction( clip );
						action.paused = false;
						action.setLoop( LoopOnce );
						action.clampWhenFinished = true;
					} );

					
					setTimeout(()=>{
						gsap.to(_this.gltf.scene.rotation, { 
							duration: 1.5, 
							ease: "power2.out",
							y: .45,
						});
						setTimeout(()=>{
							gsap.to(_this.camera.position, { 
								duration: .7, 
								ease: "power2.out",
								z: 993,
							});
							document.querySelector(".halloween-2025-entrance-smoke")?.classList.add('speeding');
							setTimeout(()=>{
								document.querySelector(".halloween-2025-entrance-front")?.classList.add('speeding');
								setTimeout(()=>{
									document.querySelector(".halloween-2025-entrance-back")?.classList.add('speeding');
									document.querySelector(".halloween-2025-index-container")?.classList.add('animation-finished');
								
									setTimeout(()=>{
										document.querySelector(".halloween-2025-entrance")?.classList.add('entrance-end');
										document.querySelector(".halloween-2025-panel-b")?.classList.add('halloween-show');
										
										// (globalStore.breakpoint == 'mobile') ? 
										// document.querySelector(".halloween-2025-img .halloween-2025-mobile")?.play() : 
										// document.querySelector(".halloween-2025-img .halloween-2025-desktop")?.play();

										setTimeout(()=>{
											document.querySelector('.halloween-2025-entrance').remove();
											_this.finished = true;
										},600)
									},400)
								},100)
							},100)
						},500)
					},3500)
				},150)
			},150)
		}
	}

	buttonPress = () => {
		let pressTimer: any;
		let countdownTime = 100;
		let currentTime = 0;
		let countdownInterval: any;

		const startPress = (event: any) => {
			var e = event || window.event;
			var btnCode;

			// For touch events, we can use the first touch point
			if (e.touches) {
				btnCode = 0; // Simulating left button press
			} else {
				btnCode = e.button;
			}

			if (btnCode == 0) {
				clearInterval(countdownInterval);

				countdownInterval = setInterval(() => {
					currentTime++;
					// let percent = Math.ceil((currentTime / countdownTime) * 100) + '%';
					let percent = currentTime / countdownTime;
					// this.indicatorCircle.style.height = percent;
					// console.log('this.indicatorCircle',this.indicatorCircle);
					// console.log(percent);
					this.indicatorCircle.style.strokeDashoffset = 480-(percent * 480);

					if (currentTime == countdownTime) {
						clearInterval(countdownInterval);
						currentTime = 0;
						this.openingAnimation();
					}
				}, 10);
			}
		};

		const endPress = () => {
			clearInterval(countdownInterval);
		};

		this.cursorButton.addEventListener('mousedown', startPress);
		this.cursorButton.addEventListener('touchstart', startPress);
		this.cursorButton.addEventListener('mouseup', endPress);
		this.cursorButton.addEventListener('touchend', endPress);
		this.cursorButton.addEventListener('mouseleave', endPress); // To handle mouse leaving the button
	};


	smoke = ()=>{
		var camera:any, scene:any, renderer:any,
		clock:any, cubeSineDriver:any, light:any, smokeGeo:any, smokeParticles:any, delta:any;
		
		// var container = document.querySelector(".halloween-content");
		var ratio = 3;
		const _this = this;
		
		init();

		function init() {
			clock = new Clock();

			renderer = new WebGLRenderer();
			renderer.setSize( window.innerWidth, window.innerHeight );

			scene = new Scene();
		
			camera = new PerspectiveCamera( 40, window.innerWidth / window.innerHeight, 1, 10000 );
			_this.camera = camera;
			camera.position.z = 1000;
			scene.add( camera );

			var group = new Group();
			_this.group = group;
			const onMouseMove = (e: any) => {
				if(!_this.allowMouse) return;
				const rateX = 0.3;
				const rateY = 1;
				const rect = _this.wrapper.getBoundingClientRect();
				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;

				const cx = rect.width / 2;
				const cy = rect.height / 2;

				const rx = (cx - x) / cx;
				const ry = (cy - y) / cy;

				group.rotation.x = ry*rateX;
				group.rotation.y = -.4+rx*rateY;
			};
			
            window.addEventListener('mousemove', onMouseMove, false);
            window.addEventListener('resize', onWindowResize, false);
		
			cubeSineDriver = 0;

			light = new DirectionalLight(0xffffff,4);
			light.position.set(-1,-1,1000);
			scene.add(light);

			let light2 = new DirectionalLight(0xfdaa02,4);
			light2.position.set(0,0,1000);
			scene.add(light2);

			// Create a new instance of TextureLoader
			const tloader = new TextureLoader();

			// Load the texture
			tloader.load(
				imgPath+'entrance/smoke-element.png',
				function (texture) {
					// smokeMaterial = new MeshLambertMaterial({color: 0x00dddd, map: smokeTexture, transparent: true});
					const smokeMaterial = new MeshLambertMaterial({color: 0x216076, map: texture, transparent: true});
					const smokeMaterial2 = new MeshLambertMaterial({color: 0x849095, map: texture, transparent: true});
					const smokeMaterial3 = new MeshLambertMaterial({color: 0x3a2121, map: texture, transparent: true});
					
					// var tempUnit = container.clientHeight / 3;
					smokeGeo = new PlaneGeometry(300,300);
					smokeParticles = [];
		
					for (var p = 0; p < 25; p++) {
						let mysmokeMaterial:any = smokeMaterial.clone();
						if(Math.round(Math.random()*3)==0){
							mysmokeMaterial = smokeMaterial2.clone();
						}else if(Math.round(Math.random()*3)==1){
							mysmokeMaterial = smokeMaterial3.clone();
						}
						var particle = new Mesh(smokeGeo,mysmokeMaterial);
						particle.position.set(Math.random()*800-400,Math.random()*500-600,Math.random()*800+200);
						particle.rotation.z = Math.random() * 360;
						scene.add(particle);
						smokeParticles.push(particle);
					}
					for (var p = 0; p < 15; p++) {
						let mysmokeMaterial:any = smokeMaterial.clone();
						if(Math.round(Math.random()*3)==0){
							mysmokeMaterial = smokeMaterial2.clone();
						}else if(Math.round(Math.random()*3)==1){
							mysmokeMaterial = smokeMaterial3.clone();
						}
						// let mysmokeMaterial:any = smokeMaterial4.clone();
						var particle = new Mesh(smokeGeo,mysmokeMaterial);
						particle.position.set(Math.random()*300-150,Math.random()*500-250,Math.random()*800-100);
						particle.rotation.z = Math.random() * 360;
						scene.add(particle);
						smokeParticles.push(particle);
					}
					animate();
		
				},
				undefined, // Optional: onProgress callback
				function (err) {
					// Error during loading
					console.error('An error occurred while loading the texture:', err);
				}
			);
		
			document.querySelector('.halloween-2025-entrance-texture').appendChild( renderer.domElement );

			//LOAD GLB
			const loader = new GLTFLoader();
			const dracoLoader = new DRACOLoader();
			// dracoLoader.setDecoderPath( 'three/examples/jsm/libs/draco/' );
			dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
			loader.setDRACOLoader( dracoLoader );
			loader.load(
				// resource URL
				modelPath+'box-intro.glb',
				// called when the resource is loaded
				async function ( gltf ) {
					let glb = gltf.scene;
					group.add( glb );
					scene.add( group );
	
					group.position.z = 990;
					// group.position.x = .1;
					if(window.innerWidth>767){
						glb.position.y = -1.4;
					}else{
						glb.position.y = -1;
					}
					// group.rotation.y = 1.1;
					group.rotation.y = Math.PI;

					group.scale.x = 0;
					group.scale.y = 0;
					group.scale.z = 0;

					setTimeout(()=>{
						gsap.to(group.rotation, { 
							duration: 1, 
							ease: "power2.out",
							y: -.4
						});
						const groupScale = window.innerWidth>767 ? 1 : .8;
						gsap.to(group.scale, { 
							duration: 1, 
							ease: "power2.out",
							x: groupScale,
							y: groupScale,
							z: groupScale
						});
					},1000)

					_this.gltf = gltf;
					let mixer = new AnimationMixer( gltf.scene );
					_this.mixer = mixer;

					_this.gltf.animations.forEach( (clip:any) => {
						const action = _this.mixer.clipAction( clip );
						action.play(); 
						action.paused = true;
					} );
					
					setTimeout(()=>{
						_this.allowMouse = true;
					},1000)
				},
				// called while loading is progressing
				function ( xhr ) {
				},
				// called when loading has errors
				function ( error ) {
					console.log( 'An error happened' );
				}
			);
		
		}
		
		function animate() {
			// note: three.js includes requestAnimationFrame shim
			// stats.begin();
			delta = clock.getDelta();
			if(!_this.finished){
				requestAnimationFrame( animate );
			}
			if(_this.mixer){
				_this.mixer.update( delta ); // Update the mixer with the elapsed time
			}

			evolveSmoke();
			render();
			// stats.end();
		}
		
		function evolveSmoke() {
			var sp = smokeParticles.length;
			while(sp--) {
				smokeParticles[sp].rotation.z += (delta * 0.2);
			}
		}

		function render() {
			cubeSineDriver += .01;
			renderer.render( scene, camera );
		}

		function onWindowResize() {
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();

			const groupScale = window.innerWidth>767 ? 1 : .8;
			_this.group.scale.x = groupScale;
			_this.group.scale.y = groupScale;
			_this.group.scale.z = groupScale;

            renderer.setSize(window.innerWidth, window.innerHeight);
        }
	}
	debugMode(){
		const urlParams = new URLSearchParams(window.location.search);
		const myParam = urlParams.get('debug');

		if(myParam=='1'){
			this.finished = true;
			// console.log('debug mode', globalStore.breakpoint);
			document.querySelector(".halloween-2025-index-container")?.classList.add('animation-entered');
			document.querySelector(".halloween-2025-entrance")?.classList.add('entrance-debug');
			document.querySelector(".halloween-2025-index-container")?.classList.add('animation-finished');
			document.querySelector(".halloween-2025-panel-b")?.classList.add('halloween-show');
			document.querySelector('.footer')?.classList.add('show-footer');
			document.querySelector('.halloween-2025-entrance').remove();

			// (globalStore.breakpoint == 'mobile') ? 
			// document.querySelector(".halloween-2025-img .halloween-2025-mobile")?.play() : 
			// document.querySelector(".halloween-2025-img .halloween-2025-desktop")?.play();
		}
	}
}